document.addEventListener('DOMContentLoaded', function () {
  // Run only on devices that support hover (desktop)
  const desktop = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!desktop.matches) return;

  // Find all dropdown <details> in header
  document.querySelectorAll('header details').forEach((menu) => {
    menu.addEventListener('mouseenter', () => menu.setAttribute('open', ''));
    menu.addEventListener('mouseleave', () => menu.removeAttribute('open'));
  });
});
